import TimelineContainer from 'common/timeline/containers/timeline-container';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';
import { referenceTypes } from '../../utils/app-configs';

const EquipmentTimeline = ({ id, renderMenu, renderConnectionStatus, ...rest }) => {
  const params = useParams();
  return <>
    <TimelineContainer
      id={id}
      type={referenceTypes.equipment}
      jumpToDate={
        params.filtervalue
          ? null
          : params.jumpToDateOrFilter
      }
      activeFilter={
        params.filtervalue && params.jumpToDateOrFilter
      }
      activeFilterValue={params.filtervalue}
      canCreateTicket={true}
      canCreateOrder={true}
      renderMenu={renderMenu}
      renderConnectionStatus={renderConnectionStatus}
      {...rest}
    />
  </>;
};

EquipmentTimeline.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
  renderConnectionStatus: PropTypes.func,
};

export default EquipmentTimeline;
